import React, { useState } from "react";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import TimeLineTarget from "./TimeLine/TimeLineTarget";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { EjercicioSelect } from "../../helpers/EjercicioSelected";
import PeriodoSelected from "../../helpers/PeriodoSelected";

export const FiltradoOperacionesCredito = ({ onExecute, msgTitulo }) => {
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState({
    ejercicio: "",
    periodo: "",
  });
  const onOpenModal = () => {
    const container = document.getElementById("mdlFiltros-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  const onCargar = () => {
    if (
      state.ejercicio === undefined ||
      state.ejercicio === null ||
      state.ejercicio === ""
    ) {
      Swal.fire(
        "RESUMEN DE OPERACIONES DE VENTA",
        "Favor de seleccionar el ejercicio",
        "warning"
      );
      return;
    }
    onExecute(state.ejercicio, state.periodo).then(() => {
      onOpenModal();
    });
  };
  return (
    <div className="plantilla-screen-filtro">
      <div
        className="plantilla-screen-filtro-button-modal"
        onClick={onOpenModal}
      >
        <FilterAltIcon /> Filtrar
      </div>
      <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
        <PlantillaScreen
          titulo={`Filtro`}
          className_main={1}
          className={"plantilla-screen-filtro-container-modal"}
        >
          <div className="plantilla-screen-filtro-container-modal-container">
            <EjercicioSelect
              start_year={2024}
              value={state.ejercicio}
              onChange={(ejercicio) => setState({ ...state, ejercicio })}
            />
            <PeriodoSelected
              value={state.periodo}
              onChange={(periodo) => setState({ ...state, periodo })}
              className="plantilla-screen-filtro-container-modal-container-periodo"
            />
            <div className="plantilla-screen-filtro-container-modal-modal-acciones">
              <div
                className="plantilla-screen-filtro-container-modal-modal-acciones-cancelar"
                onClick={onOpenModal}
              >
                Cancelar
              </div>
              <div
                className="plantilla-screen-filtro-container-modal-modal-acciones-guardar"
                onClick={onCargar}
              >
                Cargar
              </div>
            </div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};
